
// DEFAULT VALUE

const defaultValue = {
    isLoading: false

}

// ACTION TYPES

const LOADING = 'LOADING'


// REDUCER

export default function VariableReducer(state = defaultValue, { type, payload }) {
    switch(type){
        case LOADING: return {...state, isLoading: payload}
        default: return state
    }

}

// ACTIONS

export const IsLoadingAction = ({isLoading}) => (dispatch) => {

    dispatch({
        type: LOADING,
        payload: isLoading
    })
}

